module.exports = __webpack_public_path__ + "static/media/PPM.835e27a5.jpg";